import React, { useState, useRef, useEffect } from "react";
import { Box } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const Logo = (props) => {
  const [imageSrc, setImageSrc] = useState('');
  const imageRef = useRef(null);
  const history = useHistory();
  
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setImageSrc('/images/logo.png');
        observer.disconnect();
      }
    },
      {threshold: 0.1}
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => observer.disconnect();
  }, [])

  return (
    <Box>
      <img
        onClick={() => history.push("/dashboard")}
        src={imageSrc}
        alt="Logo"
        {...props}
        width="auto"
        height="auto"
        ref={imageRef}
      />
    </Box>
  );
};

export default Logo;
